module.exports = __webpack_public_path__ + "img/hdp2.9111ed40.png";